import { render } from "./Registro.vue?vue&type=template&id=f5c57aa0&scoped=true"
import script from "./Registro.vue?vue&type=script&lang=js"
export * from "./Registro.vue?vue&type=script&lang=js"

import "./Registro.vue?vue&type=style&index=0&id=f5c57aa0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c57aa0"]])

export default __exports__